import {
  GetFormattedPlaylistMessageProps,
  PlaylistProps,
  PlaylistType,
} from '@osmosis/shared/types/playlist';

export const queryKeys = {
  playlistMediaData: 'getUserPlaylistMediaDataByUrl',
};

export const mockedPlaylistUser = {
  preferredName: 'TestFn',
  lastName: 'TestLn',
  avatar: 'https://gravatar.com/jpg.jpeg',
};

export const mockedQuizAllData = [
  {
    tagID: 1,
    tag: 'Step 1',
    name: 'USMLE® Step 1',
    overrideName: 'Foundational',
    type: 'step1',
    url: 'step1/questions',
  },
  {
    tagID: 25,
    tag: 'Recall',
    name: 'Foundational',
    type: 'foundationalQuestions',
    url: 'foundational/questions',
  },
];

export const mockedPlaylist = {
  playlistID: 144985,
  title: 'Test',
  list: [
    {
      title: 'test1',
      opts: { skipWatchedData: false },
      data: {
        displayTitle: 'test1',
        title: 'test1',
        nodeID: 31121379,
        mediaID: 2752720,
        description: '',
        thumbnail: '2-/_.jpg',
        poster: '1/_.jpg',
        length: '595',
        isPrime: false,
        breadcrumb: ['Microbiology', 'Virology', 'RNA Viruses', 'Retroviruses'],
        subType: 5,
      },
    },
    {
      title: 'test2',
      opts: { skipWatchedData: false },
      data: {
        displayTitle: 'test2',
        title: 'test2',
        nodeID: 31121379,
        mediaID: 2752720,
        description: '',
        thumbnail: '2-/_.jpg',
        poster: '1/_.jpg',
        length: '595',
        isPrime: false,
        breadcrumb: ['Microbiology', 'Virology', 'RNA Viruses', 'Retroviruses'],
      },
    },
  ],

  quizAllData: mockedQuizAllData,
  url: 'urlMockedPlaylist',
  type: PlaylistType.USER_OWNED,
  userOwned: true,
  progress: 0,
  userID: 1,
  user: mockedPlaylistUser,
  followers: [1],
} as PlaylistProps;

export const mockedPlaylistWithOneVideo = {
  ...mockedPlaylist,
  list: mockedPlaylist.list.slice(0, 1),
};

const playlistList = [
  {
    title: 'Introduction to titrations',
    opts: {
      skipWatchedData: true,
    },
    data: {
      quizData: {
        fc: [],
        ques: {
          step1: {
            list: [],
          },
          step2: {
            list: [],
          },
          comlex: {
            list: [],
          },
          nclex: {
            list: [],
          },
          pance: {
            list: [],
          },
          ngn: {
            list: [],
          },
          comlexl1: {
            list: [],
          },
          comlexl2: {
            list: [],
          },
          cna: {
            list: [],
          },
          foundationalQuestions: {
            list: [],
          },
          cme: {
            list: [],
          },
        },
      },
      debug: {
        watchStatusGotten: {
          no: 'No',
        },
        enteredGetWatchedDataBlock: false,
        enteredWatchedStatusBlock: false,
        getWatchedData: false,
        mediaBool: true,
        data: {
          script: 'MHFQLZbySn_ZNvQQyNB2iuOOTIqkAAcB/_.md',
          hls: 'PTKiC29eRgqebI1nQ9ZHhSC2TaGgWVJY',
          s3: 'gKfPylmXRqeRE3r80tziRTbEROeumxix.mp4',
          yt: 'm8_6gorsO_k',
          by: 'Osmosis',
          dur: '654',
          $: '9ig5a2zhTCeJLM-d3JcHKEMwRgeMo4Cx/_.jpg',
          $$: 'GcpXIsDES8iByra_Rl-owXMISNWB2o3e/_.jpg',
          muxThumbSmall: 'z3mVec94SYeuPt-Qx1Fbig-_Tya2Qs9z/_.jpg',
          muxThumb: 'FLw4WJmmRJiDAx2bBHYg4nD4S-SBAkqy/_.jpg',
          views: 36,
          progress: 0,
          lastTime: [],
        },
      },
      displayTitle: 'Introduction to titrations',
      title: 'Introduction to titrations',
      nodeID: 55680065,
      mediaID: 55680064,
      description: '',
      thumbnail: 'z3mVec94SYeuPt-Qx1Fbig-_Tya2Qs9z/_.jpg',
      poster: 'GcpXIsDES8iByra_Rl-owXMISNWB2o3e/_.jpg',
      length: '654',
      views: 36,
      progress: 0,
      lastTime: [],
      isPrime: true,
      breadcrumb: null,
      archivedStatus: 0,
    },
  },
];

export const mockedPlaylists = [
  {
    userID: 0,
    url: 'f63JqT5f3qV',
    title: 'Test2',
    userOwned: true,
    list: [],
    quizAllData: mockedQuizAllData,
    progress: 0,
    type: 1,
    followers: [],
    created: '2023-03-22T14:27:34.793Z',
    modified: '2023-03-22T14:27:34.793Z',
    playlistID: 1,
    user: mockedPlaylistUser,
    media: {
      ques: {
        step1: {
          list: [],
        },
      },
      fc: [],
    },
    subType: 5,
  },
  {
    userID: 1,
    url: 'vIP9L1fF9xW',
    title: 'Test',
    userOwned: true,
    list: playlistList,
    quizAllData: mockedQuizAllData,
    progress: 0,
    type: 1,
    followers: [],
    created: '2023-03-23T14:27:34.793Z',
    modified: '2023-03-23T14:27:34.793Z',
    playlistID: 2,
    user: mockedPlaylistUser,
    media: {
      ques: {
        step1: {
          list: [],
        },
      },
      fc: [],
    },
  },
  {
    userID: 1,
    url: 'Mxy94D70TKj',
    title: 'Test3',
    userOwned: true,
    list: playlistList,
    quizAllData: mockedQuizAllData,
    progress: 0,
    type: 1,
    followers: [],
    created: '2023-03-24T14:27:34.793Z',
    modified: '2023-03-24T14:27:34.793Z',
    playlistID: 3,
    user: mockedPlaylistUser,
    media: {
      ques: {
        step1: {
          list: [],
        },
      },
      fc: [],
    },
  },
];

export const playlistMessages = {
  alreadyExists: 'A playlist with this name already exists',
};

/**
 * GetAddToPlaylistMessage.
 */
export const getAddToPlaylistMessage = ({
  intl,
  items,
  playlistName,
}: GetFormattedPlaylistMessageProps) =>
  intl.formatMessage(
    {
      defaultMessage: `{name} {itemCount, plural,
          =0 {videos have}
          one {has}
          other {videos have}
        } been added to the playlist "{playlistName}"`,
      id: 'add-items-to-playlist-snackbar-added-text',
    },
    {
      name: items.length > 1 ? items.length : items[0].name,
      itemCount: items.length,
      playlistName,
    },
  );

/**
 * GetRemoveFromPlaylistMessage.
 */
export const getRemoveFromPlaylistMessage = ({
  intl,
  items,
  playlistName,
}: GetFormattedPlaylistMessageProps) =>
  intl.formatMessage(
    {
      defaultMessage: `{name} {itemCount, plural,
        =0 {videos have}
        one {has}
        other {videos have}
      } been removed from the playlist "{playlistName}"`,
      id: 'add-items-to-playlist-snackbar-removed-text',
    },
    {
      name: items.length > 1 ? items.length : items[0].name,
      itemCount: items.length,
      playlistName,
    },
  );
